import React from 'react';
import { ArrowUpRightIcon, HammerIcon, NewspaperIcon, QuoteIcon } from 'lucide-react';
import { LINKS } from '../data/site';
export function TrustBand() {
  return <section className="border-b border-steel-200 bg-white" aria-label="Why metal workers come to Fournier" data-id="element-260" data-mp="39zmqeu7g9vhp">
      <div className="mx-auto grid max-w-[1240px] divide-y divide-steel-200 px-5 sm:px-8 md:grid-cols-3 md:divide-x md:divide-y-0" data-id="element-261" data-mp="3iyhsbu3gojf7">
        <div className="py-7 md:pr-8" data-id="element-262" data-mp="2m9a7koao2ecc">
          <HammerIcon aria-hidden="true" className="h-5 w-5 text-fred" data-id="element-263" data-mp="2m64i37y4lag3" />
          <h2 className="mt-3 font-display text-[22px] uppercase leading-tight text-charcoal" data-id="element-264" data-mp="2r83okqp5wnh9">
            Established in 1991
          </h2>
          <p className="mt-2 max-w-[34ch] text-[15px] leading-relaxed text-steel-600" data-id="element-265" data-mp="2v72r64nf885j">
            A metal shaping tradition carried forward.
          </p>
          <a href={LINKS.story} className="mt-3 inline-flex min-h-[44px] items-center gap-2 text-[14px] font-medium uppercase tracking-[0.1em] text-charcoal transition-colors duration-150 ease-out hover:text-fred" data-id="element-266" data-mp="23gy8qbj81v6y">
            Our story
            <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-267" data-mp="1vz097rsxqu9n" />
          </a>
        </div>

        <div className="py-7 md:px-8" data-id="element-268" data-mp="1r81qklkh5k38">
          <NewspaperIcon aria-hidden="true" className="h-5 w-5 text-fred" data-id="element-269" data-mp="1r6yv00c7itgz" />
          <h2 className="mt-3 font-display text-[22px] uppercase leading-tight text-charcoal" data-id="element-270" data-mp="1m8xg7rltdgbb">
            Featured in Road &amp; Track
          </h2>
          <p className="mt-2 max-w-[34ch] text-[15px] leading-relaxed text-steel-600" data-id="element-271" data-mp="1d921xdwyp572">
            “The English Wheel”
          </p>
          <a href={LINKS.roadAndTrackFeature} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex min-h-[44px] items-center gap-2 text-[14px] font-medium uppercase tracking-[0.1em] text-charcoal transition-colors duration-150 ease-out hover:text-fred" data-id="element-272" data-mp="18b0haojw0xth">
            Read the feature
            <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-273" data-mp="vzpydh5llmi3" />
          </a>
        </div>

        <div className="py-7 md:pl-8" data-id="element-274" data-mp="10q6cl3h8tc5i">
          <QuoteIcon aria-hidden="true" className="h-5 w-5 text-fred" data-id="element-275" data-mp="10r81aar6lx5p" />
          <blockquote className="mt-3 max-w-[34ch] text-[16px] leading-relaxed text-charcoal" data-id="element-276" data-mp="m220wjgly0w8">
            “Jeff was great, very patient with me…”
          </blockquote>
          <p className="mt-2 text-[14px] text-steel-600" data-id="element-277" data-mp="qyaazify73wj">Marshall Banks · Workshop student</p>
          <a href={LINKS.testimonials} className="mt-3 inline-flex min-h-[44px] items-center gap-2 text-[14px] font-medium uppercase tracking-[0.1em] text-charcoal transition-colors duration-150 ease-out hover:text-fred" data-id="element-278" data-mp="1eod31yjv49v5">
            Read customer stories
            <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-279" data-mp="19t7gcximyr60" />
          </a>
        </div>
      </div>
    </section>;
}